import gsap from 'gsap'
import { lenis } from './lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

gsap.config({
  // nullTargetWarn: false
})

export let initAnimations, animParallaxFooter, animAbout

initAnimations = () => {
	animParallaxFooter()
	animAbout()
}

animParallaxFooter = () => {
  const footer = document.querySelector('.footer')
  const inner = footer.querySelector('.container')

  if (window.innerWidth <= 1024) return

  gsap.fromTo(inner, {
		yPercent: -32,
		scale: 1
	}, {
		scrollTrigger: {
			trigger: footer,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true
		},
		yPercent: 0,
		scale: 1
	})
}

animAbout = () => {
	const about = document.querySelector('.about-panel__inner')

	if (!about) return

	gsap.fromTo(about, {
		scale: 1.2
	}, {
		scale: 1,
		ease: 'power2.out',
		scrollTrigger: {
			trigger: about,
			start: 'top bottom',
			end: 'center center',
			scrub: true
		}
	})
}

export default () => { }